import i18n from '@/plugins/i18n';
import type { RouteLocationNormalized } from 'vue-router';

export const routeTitle = (route: RouteLocationNormalized): string => {
    if (route.meta.pageTitle) {
        return i18n.global.t('pageTitle.' + route.meta.pageTitle.toString());
    } else {
        return '';
    }
};

export function setTabTitle({
    title,
    separator = ' | ',
    prefix = '',
    suffix = 'BUYLO',
}: {
    title: string;
    separator?: string;
    prefix?: string;
    suffix?: string;
}): void {
    const formattedTitle = `${prefix}${prefix !== '' ? separator : ''}${title}${suffix !== '' ? separator : ''}${suffix}`;
    document.title = formattedTitle;
}
